<template>
    <section class="vue-lightbox">
      <div class="container b-block__heading">
        <h2 class="b-block__title">
          Коттеджи {{cottage_name}}
        </h2>
        <button class="btn b-rating-filter__mobile-btn" @click.prevent="showModal()">
          <svg viewBox="0 0 24 24" >
            <use xlink:href="/assets/site/images/sprites.svg?ver=39#sprite-filters-btn"></use>
          </svg>
        </button>
      </div>
        <apartment-filter
            @filterSubmit="filterSubmit"
            :roomsList = filterRoomsList
            @clearFilter="clearFilter"
        ></apartment-filter>
        <div class="container">
            <ul class="clean-list ">
                <apartment v-for="apartment in apartments"
                           :apartment="apartment"
                           :key="apartment.id"
                            @open-gallery="openGallery"
                           @showModal="modalShow"
                >
                </apartment>
            </ul>
        </div>
      <modal :id="'apartment_filter'" ref="modal"
        :header_class="'modal-header--underline'"
      >
        <template v-slot:title>
          Фильтры
        </template>
        <apartment-filter
            ref="filters"
            @filterSubmit="filterSubmit"
            :roomsList = filterRoomsList
            @clearFilter="clearFilter"
            :class="'apartment-filter--mobile'"
        ></apartment-filter>
        <template v-slot:button>
          Показать
          {{apartments.length}}
          {{num_word(apartments.length, words)}}
        </template>
      </modal>
      <apartment-modal :type="apartment_type" :id="apartment_id" v-if="ShowModal" @close="closeModal"></apartment-modal>
        <light-box ref="lightbox"
                  :media="gallery"
                  :show-caption="false"
                  :show-light-box="false">

        </light-box>
    </section>
</template>
<script>
    import apartment from './item'
    import filter from "./filter";
    import modal from "../../common/bootstrap-modal"
    import  ApartmentModal from "./modal"
    import LightBox from 'vue-image-lightbox'
    export default {
        components: {
            'apartment':apartment, LightBox,
            'ApartmentFilter':filter,
            'modal':modal,
            'ApartmentModal': ApartmentModal,
        },

        props:['cottage_id', 'cottage_name'],
        data() {
            return {
              apartment_id:null,
              words:[
                'коттедж',
                'коттеджа',
                'коттуджей'
              ],
                gallery:[
                  {
                    thumb: '',
                    src: '',
                  }
                ],
                apartments: [],
                apartment_type: "",
                filterRoomsList: [],
              ShowModal:false,
            }
        },
        methods: {
          modalShow(data) {
            this.apartment_id = data.id;
            this.apartment_type = data.type;
            this.ShowModal =true;
            let vm =this;
            this.$nextTick(function () {
              $(function () {
                $('#apartmentModal').modal('show')
              })

            })
          },
          closeModal() {
            $('#apartmentModal').modal('hide');
            let vm =this;
            $('#apartmentModal').on('hidden.bs.modal', function (e) {
              vm.ShowModal = false;
            })
          },
          onResize() {
            this.windowWidth = window.innerWidth
            if(this.windowWidth >1023) {
              this.$refs.modal.closeModal();
            }
          },
          num_word(value, words){
            value = Math.abs(value) % 100;
            var num = value % 10;
            if(value > 10 && value < 20) return words[2];
            if(num > 1 && num < 5) return words[1];
            if(num == 1) return words[0];
            return words[2];
          },
          showModal() {
              this.$refs.modal.openModal();
          },
            openGallery(media) {

                this.gallery = media;
                this.$refs.lightbox.showImage(0);
            },
            getApartments() {
                axios.get('/api/village/' + this.cottage_id + '/cottages')
                    .then((response) => {
                        this.apartments = response.data;
                        let roomsList = response.data.map(function(item){
                            return item.rooms
                        });
                       this.filterRoomsList =  roomsList.filter(function(value, index, self){
                            return self.indexOf(value) === index;
                        });
                    })
            },

            filterSubmit(form) {
                axios.get('/api/village/' + this.cottage_id + '/cottages', { params: form})
                    .then((response) => {
                        this.apartments = response.data;
                    })
            },
            clearFilter() {
                this.getApartments();
            },
        },
        mounted() {
            this.getApartments();
          this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
          })
        },
      beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
      },
    }
</script>